// EN
import enCommon from './locales/en/common.json';
import enNavbar from './locales/en/navbar.json';
import enFooter from './locales/en/footer.json';
import enHome from './locales/en/home.json';
import enAbout from './locales/en/about.json';
import enPricing from './locales/en/pricing.json';
import enFeatures from './locales/en/features.json';
import enSecurity from './locales/en/security.json';
import enPartners from './locales/en/partners.json';
import enPrivacy from './locales/en/privacy.json';
import enTerms from './locales/en/terms.json';
import enContact from './locales/en/contact.json';
import enWaitingList from './locales/en/waitingList.json';

// ES
import esCommon from './locales/es/common.json';
import esNavbar from './locales/es/navbar.json';
import esFooter from './locales/es/footer.json';
import esHome from './locales/es/home.json';
import esAbout from './locales/es/about.json';
import esPricing from './locales/es/pricing.json';
import esFeatures from './locales/es/features.json';
import esSecurity from './locales/es/security.json';
import esPartners from './locales/es/partners.json';
import esPrivacy from './locales/es/privacy.json';
import esTerms from './locales/es/terms.json';
import esContact from './locales/es/contact.json';
import esWaitingList from './locales/es/waitingList.json';

// FR
import frCommon from './locales/fr/common.json';
import frNavbar from './locales/fr/navbar.json';
import frFooter from './locales/fr/footer.json';
import frHome from './locales/fr/home.json';
import frAbout from './locales/fr/about.json';
import frPricing from './locales/fr/pricing.json';
import frFeatures from './locales/fr/features.json';
import frSecurity from './locales/fr/security.json';
import frPartners from './locales/fr/partners.json';
import frPrivacy from './locales/fr/privacy.json';
import frTerms from './locales/fr/terms.json';
import frContact from './locales/fr/contact.json';
import frWaitingList from './locales/fr/waitingList.json';

// DE
import deCommon from './locales/de/common.json';
import deNavbar from './locales/de/navbar.json';
import deFooter from './locales/de/footer.json';
import deHome from './locales/de/home.json';
import deAbout from './locales/de/about.json';
import dePricing from './locales/de/pricing.json';
import deFeatures from './locales/de/features.json';
import deSecurity from './locales/de/security.json';
import dePartners from './locales/de/partners.json';
import dePrivacy from './locales/de/privacy.json';
import deTerms from './locales/de/terms.json';
import deContact from './locales/de/contact.json';
import deWaitingList from './locales/de/waitingList.json';

// FIL
import filCommon from './locales/fil/common.json';
import filNavbar from './locales/fil/navbar.json';
import filFooter from './locales/fil/footer.json';
import filHome from './locales/fil/home.json';
import filAbout from './locales/fil/about.json';
import filPricing from './locales/fil/pricing.json';
import filFeatures from './locales/fil/features.json';
import filSecurity from './locales/fil/security.json';
import filPartners from './locales/fil/partners.json';
import filPrivacy from './locales/fil/privacy.json';
import filTerms from './locales/fil/terms.json';
import filContact from './locales/fil/contact.json';
import filWaitingList from './locales/fil/waitingList.json';

export const resources = {
  en: {
    common: enCommon,
    navbar: enNavbar,
    footer: enFooter,
    home: enHome,
    about: enAbout,
    pricing: enPricing,
    features: enFeatures,
    security: enSecurity,
    partners: enPartners,
    privacy: enPrivacy,
    terms: enTerms,
    contact: enContact,
    waitingList: enWaitingList
  },
  es: {
    common: esCommon,
    navbar: esNavbar,
    footer: esFooter,
    home: esHome,
    about: esAbout,
    pricing: esPricing,
    features: esFeatures,
    security: esSecurity,
    partners: esPartners,
    privacy: esPrivacy,
    terms: esTerms,
    contact: esContact,
    waitingList: esWaitingList
  },
  fr: {
    common: frCommon,
    navbar: frNavbar,
    footer: frFooter,
    home: frHome,
    about: frAbout,
    pricing: frPricing,
    features: frFeatures,
    security: frSecurity,
    partners: frPartners,
    privacy: frPrivacy,
    terms: frTerms,
    contact: frContact,
    waitingList: frWaitingList
  },
  de: {
    common: deCommon,
    navbar: deNavbar,
    footer: deFooter,
    home: deHome,
    about: deAbout,
    pricing: dePricing,
    features: deFeatures,
    security: deSecurity,
    partners: dePartners,
    privacy: dePrivacy,
    terms: deTerms,
    contact: deContact,
    waitingList: deWaitingList
  },
  fil: {
    common: filCommon,
    navbar: filNavbar,
    footer: filFooter,
    home: filHome,
    about: filAbout,
    pricing: filPricing,
    features: filFeatures,
    security: filSecurity,
    partners: filPartners,
    privacy: filPrivacy,
    terms: filTerms,
    contact: filContact,
    waitingList: filWaitingList
  }
};
